module.exports = __webpack_public_path__ + "static/image3-879428ba710a754651f303c41f01b3c1.png";